import { createReducer } from 'common-src/utils/reducerUtils';

import {
  SET_CARE_ORCH_ERROR,
  SET_CARE_ORCH_LAST_FETCHED_AT,
  SET_CARE_ORCH_LOADING,
  SET_CARE_ORCH_META,
  SET_CARE_ORCH_STATS,
} from './actionTypes';

const initialState = {
  isLoading: false,
  error: null,
  stats: null,
  meta: {
    tasks: null,
    appointments: null,
    readiness: null,
    stats: null,
  },
  lastFetchedAt: null,
};

const entityHandlers = {
  [SET_CARE_ORCH_LOADING]: (state, payload) => ({
    ...state,
    isLoading: payload.isLoading,
  }),
  [SET_CARE_ORCH_ERROR]: (state, payload) => ({
    ...state,
    error: payload.error,
  }),
  [SET_CARE_ORCH_STATS]: (state, payload) => ({
    ...state,
    stats: payload.stats,
  }),
  [SET_CARE_ORCH_META]: (state, payload) => ({
    ...state,
    meta: {
      ...state.meta,
      ...payload.meta,
    },
  }),
  [SET_CARE_ORCH_LAST_FETCHED_AT]: (state, payload) => ({
    ...state,
    lastFetchedAt: payload.lastFetchedAt,
  }),
};

export const reducer = createReducer(initialState, entityHandlers);
